import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text", "button"]

  declare textTarget: HTMLElement
  declare buttonTarget: HTMLElement
  declare hasButtonTarget: boolean

  private _clampClass: string | null = null

  get clampClass(): string {
    if (!this._clampClass) {
      this._clampClass =
        Array.from(this.textTarget.classList).find((c) => /^line-clamp-/.test(c)) || "line-clamp-3"
    }
    return this._clampClass
  }

  connect() {
    this.checkTruncation()
  }

  checkTruncation() {
    if (!this.hasButtonTarget) return

    // Check if text is actually truncated
    const text = this.textTarget
    const isTruncated = text.scrollHeight > text.clientHeight

    this.buttonTarget.classList.toggle("hidden", !isTruncated)
  }

  toggle() {
    const clamp = this.clampClass
    const isExpanding = this.textTarget.classList.contains(clamp)
    this.textTarget.classList.toggle(clamp)

    // Toggle expanded class on the card for mobile overlay behavior
    const card = this.element.closest(".arena-prompt")
    if (card) {
      card.classList.toggle("prompt-expanded", isExpanding)
    }

    if (this.hasButtonTarget) {
      this.buttonTarget.textContent = this.textTarget.classList.contains(clamp)
        ? "Show all"
        : "Show less"
    }
  }
}
